import React from 'react';

import AppContent from '../shared/AppContent';
import {AuthContext} from "../../authContext";
import { getLibraryCategories, searchLibraryItems} from "../data/dataCIMToolkit";
import Image from "../shared/Image";
import Loading from "../shared/Loading";
import { theme } from "../../configuration";
import HelpResultCard from "../help/HelpResultCard";
import HelpResultCardContainer from "../help/HelpResultCardContainer";
import TextInput from "../shared/form/TextInput";
import Flex from "../shared/Flex";
import LibraryItemCollection from "./LibraryItemCollection";
import PageHeading from "../shared/PageHeading";
import PrivateLibraryBadge from "../shared/PrivateLibraryBadge";
import { isActiveSiteLayoutToolkitUser } from "../shared/utilities/isActiveSiteLayoutToolkitUser";

class Library extends React.Component {
  state = {
    categories: [],
    items: [],
    isLoading: true,
    searchTermConsistencyTimer: 0,
    previousSearchTerms: "",
    searchTerms: "",
  };
  static contextType = AuthContext;
  componentDidMount = async () => {
    this.loadAllCategories();

    this.searchInterval = setInterval(async () => {
      this.setState({searchTermConsistencyTimer: this.state.searchTermConsistencyTimer + 1});

      if (this.state.searchTerms.length > 2 && this.state.searchTermConsistencyTimer > 5 && this.state.searchTerms !== this.state.previousSearchTerms) {
        const searchResults = await searchLibraryItems(this.state.searchTerms, this.context.token);
        await this.setState({previousSearchTerms: this.state.searchTerms, searchTermConsistencyTimer: 0, categories: searchResults.data.categories, items: searchResults.data.items});
      }

      if (this.state.searchTerms.length < 3 && this.state.searchTermConsistencyTimer > 5 && this.state.searchTerms !== this.state.previousSearchTerms) {
        await this.setState({previousSearchTerms: this.state.searchTerms, searchTermConsistencyTimer: 0, categories: [], items: [], isLoading: false})
        await this.loadAllCategories();
      }
    }, 100);
  };
  componentWillUnmount = async () => {
    clearInterval(this.searchInterval);
  };
  handleSearchInputChange = async e => {
    await this.setState({searchTerms: e.target.value});
  };
  loadAllCategories = async () => {
    const categories = await getLibraryCategories(this.context.token);
    await this.setState({
      isLoading: false,
      categories: categories.data
    });
  }
  render() {
    return (
      <AppContent>
        <PageHeading>
          {
            isActiveSiteLayoutToolkitUser(this.context.userDetails.licences)
              ?
              'Site Objects'
              :
              'Library'
          }
        </PageHeading>
        <p>
          {
            isActiveSiteLayoutToolkitUser(this.context.userDetails.licences)
            ?
            'Search for an object to add to your site'
            :
            'Search for a city item which you can add to your CityCAD model'
          }
        </p>
        <Flex style={{marginBottom:"7px"}}>
          <TextInput
              value={this.state.searchTerms}
              autoComplete={"off"}
              placeholder={`Start typing to see search results below...`}
              name="searchTerms"
              type="text"
              onChange={this.handleSearchInputChange}
          /><br />
        </Flex>
        {
          this.state.items.length > 0
          &&
          <React.Fragment>
            <p>Found {this.state.items.length} item{this.state.items.length !== 1 && `s`}</p>
            <LibraryItemCollection items={this.state.items} />
          </React.Fragment>
        }
        {
          this.state.searchTerms !== ""
          &&
          <p>Found {this.state.categories.length} categor{this.state.categories.length === 1 ? `y` : `ies`}</p>
        }
        {
          this.state.isLoading === true
          ?
          <Loading />
          :
          <HelpResultCardContainer>
            {
              this.state.categories.map(category => {
                return (
                  <HelpResultCard
                    paddingNarrow={`0px`}
                    onClick={e => {e.preventDefault(); this.context.navigate(`./library/category/${category.id}`)}}
                    key={category.id}
                  >
                    <div>
                      <Image
                        maxWidth={theme.libraryThumbnailMaxWidth}
                        src={`https://www.holisticcity.co.uk/images/components/${category.image}`}
                        alt={category.name}
                      />
                    </div>
                    <div style={{marginLeft:"10px"}}>
                      {category.name}<br />
                      {/*{this.context.userDetails.userID === Number(category.userID) && <PrivateLibraryBadge />}<br />*/}
                      <small>{category.itemCount} city item{Number(category.itemCount) !== 1 && 's'}</small>
                    </div>
                  </HelpResultCard>
                )
              })
            }
          </HelpResultCardContainer>
        }
      </AppContent>
    );
  }
}

export default Library;
